import React, { useEffect, useState } from "react";
import { Box, TextField, Button, Typography, Avatar, Chip, Alert, Modal } from "@mui/material";
import MjLabel from "../../../components/ui/MjLabel";
// import DefaultProfilePic from "../../imgs/user.png";
import MyDPFullDate from "../../../components/ui/MyDPFullDate";
import { useParams } from "react-router-dom";
import { useAuthContext } from "../../../hooks/useAuthContext";
import { Form, Formik, ErrorMessage, Field } from "formik";
import Api from "../../../api/Api";
import { Urls } from "../../../api/Urls";
import { colors } from "../../../theme/Colors";
import * as Yup from "yup";
import BoxContainer from "../../../components/ui/BoxContainer";
import ButtonSquare from "../../../components/ui/ButtonSquare";
import MjErrorText from "../../../components/ui/MjErrorText";
import { ToastContainer, toast } from "react-toastify";

function ProblemesDetails() {
  const [change, setChange] = useState(0);
  const params = useParams();
  const { user } = useAuthContext();
  const access_token = user?.access_token;
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [open, setOpen] = useState(false);
  const [action, setAction] = useState("");
  const [problem, setProblem] = useState({});
  const [openTraiterProbleme, setOpenTraiterProbleme] = useState(false);

  const initialValues = {
    date: "",
  };

  const validationSchema = Yup.object().shape({
    date: Yup.string().required("Ce champs est obligatoire"),
  });

  useEffect(() => {
    Api.get(Urls.GET_DETAILS_PROBLEME + params.id, {
      headers: { "content-type": "application/json", authorization: `Bearer ${access_token}` },
    })
      .then((res) => {
        console.log(res.data);
        setProblem(res.data.problem);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [change]);

  const TraiterProbleme = (values, id) => {
    console.log("hi");
    Api.post(
      "/admin/problems/" + id + "/fix-problem",
      {
        date: values.date,
      },
      {
        headers: { "content-type": "application/json", authorization: `Bearer ${access_token}` },
      }
    )
      .then((res) => {
        console.log(res);
        setChange((change) => change + 1);
      })

      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <Box>
      {/* Header Section */}

      <Box display="flex" flexDirection="column" sx={{ maxWidth: "700px" }}>
        <ToastContainer />
        <BoxContainer>
          <Box marginBottom="21px">
            <Typography variant="text_normal" fontSize="20px" fontWeight="700" lineHeight="32px">
              #{problem.id}
            </Typography>
          </Box>

          {/* <pre>{JSON.stringify(problem, null, 2)}</pre> */}
          <Box marginBottom="10px" display="flex" flexDirection="row" gap="10px" alignItems="center">
            <Typography variant="text_normal" fontSize="14px" fontWeight="500" lineHeight="32px">
              Déclaré par
            </Typography>
            <Chip variant="active_offer" label={problem.declared_by} />
          </Box>
          <Box marginBottom="10px" display="flex" flexDirection="row" gap="10px" alignItems="center">
            <Typography variant="text_normal" fontSize="14px" fontWeight="500" lineHeight="32px">
              Motif du problème
            </Typography>
            <Chip variant="rejected_offer" label={problem?.interim_problem_reason ? problem?.interim_problem_reason?.name : problem?.enterprise_problem_reason?.name} />
          </Box>
          <Box marginBottom="10px" display="flex" flexDirection="row" gap="10px" alignItems="top">
            <Typography variant="text_normal" fontSize="14px" fontWeight="500" lineHeight="32px">
              Détail du problème
            </Typography>
            <Typography variant="text_normal" fontSize="14px" fontWeight="600" lineHeight="32px" maxWidth="500px">
              {problem.detail}
            </Typography>
          </Box>
          <Box marginTop="20px" display="flex" flexDirection="row-reverse" gap="10px" alignItems="top">
            <Typography variant="text_normal" fontSize="14px" fontWeight="600" lineHeight="32px" maxWidth="500px">
              {problem.created_at}
            </Typography>
            <Typography variant="text_normal" fontSize="14px" fontWeight="500" lineHeight="32px">
              Déclaré le
            </Typography>
          </Box>
        </BoxContainer>
        <Box marginTop="10px" display="flex" flexDirection="row-reverse">
          <Button variant="mj_secondary_md" onClick={() => setOpenTraiterProbleme(true)}>
            Traiter le problème
          </Button>
        </Box>

        <Modal sx={{ display: "flex", justifyContent: "center", alignItems: "center" }} open={openTraiterProbleme} onClose={() => setOpenTraiterProbleme(false)}>
          <Box padding="40px" sx={{ bgcolor: "white", borderRadius: "6px" }}>
            <Box marginBottom="40px" display="flex" justifyContent="space-between" alignItems="center">
              <Typography variant="text_xxl" fontWeight="700">
                Traiter le problème
              </Typography>
              <ButtonSquare onClick={() => setOpenTraiterProbleme(false)} action="close" />
            </Box>

            <Formik
              //initial values
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={(values) => {
                TraiterProbleme(values, problem.id);
                setOpenTraiterProbleme(false);
              }}
            >
              {({ values, setFieldValue }) => (
                <Form>
                  {/* <pre>{JSON.stringify(values, null, 2)}</pre> */}
                  <Box marginBottom="20px">
                    <Typography variant="text_normal"> Saisissez la date de traitement du problème</Typography>
                  </Box>
                  <Box flex={1} alignItems="center" marginRight="1rem" marginBottom="20px">
                    <Field fullWidth name="date" as={MyDPFullDate} setFieldValue={setFieldValue} variant="outlined" label="Date traitement du problème" size="small" />
                    <ErrorMessage name="date" component={MjErrorText} />
                  </Box>

                  <Box display="flex" flexDirection="row-reverse" gap="10px">
                    <Button variant="mj_secondary_md" onClick={() => setOpenTraiterProbleme(false)}>
                      Annuler
                    </Button>
                    <Button variant="mj_primary_md" type="submit">
                      Traiter
                    </Button>
                  </Box>
                </Form>
              )}
            </Formik>
          </Box>
        </Modal>
      </Box>
    </Box>
  );
}

export default ProblemesDetails;
